<template>

  <div>
    
    <div v-if="permissions.includes('manage_candidates')">

      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To add an event, select a job') }}
      </div>

      <div
        v-if="selectedJob"
        class="card">
        <div class="card-body">
          <CandidateEventForm
            :initValue="{}"
            :jobId="selectedJob._id"
            @created="created" />
        </div>
      </div>

    </div>

    <CandidateFeed :activityType="'event'" />

  </div>

</template>

<script>
import CandidateEventForm from './CandidateEventForm'
import CandidateFeed from '../Feed/CandidateFeed'

export default {
  name: 'CandidateEvent',
  components: {
    CandidateEventForm,
    CandidateFeed
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    created (event) {
      return this.$store.dispatch('refreshSelectActivities')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Event/CandidateEvent.vue